export function getConfig() {
    try {
        const config = getMeta("custom_config")
        var decoded = decodeURIComponent(config);
        return JSON.parse(decoded);
    } catch (error) {
        return {}
    }
}

export function getApiURL() {
    var configObject = getConfig()
    var API_URL = configObject.API_URL
    if (API_URL) {
        return API_URL;
    } else {
        return "http://store.goorder.pl";
        // return "http://store.goorder.local";
    }
}

function getMeta(metaName) {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content');
        }
    }
    return '';
}

export function isDebug() {
    if (process.env.REACT_APP_DEBUG) {
        return false;
    }
    return false;
}


export const getGoogleAnalyticsId = () => {
    const id = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

    if (id) return id;

    return undefined;
}